import { render, staticRenderFns } from "./icon-columns.vue?vue&type=template&id=159ee950&"
import script from "./icon-columns.vue?vue&type=script&lang=js&"
export * from "./icon-columns.vue?vue&type=script&lang=js&"
import style0 from "./icon-columns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports